import { Paper } from '@mantine/core';
import PayersList from './PayersList';

export default function PayersPage() {
  return (
    <Paper p="md" h="100%">
      <PayersList />
    </Paper>
  );
}
